import { useNavigate, useParams } from "react-router-dom";
import { get_by_transaction_id } from "../../constants/apis";
import { useAppContext } from "../../context/AppContext";
import { useFetch } from "../../hooks/useFetch";
import { TransactionSummaryRes } from "../../types/TransactionSummary";

import PaymentService from "../../components/Admin/PaymentService";
import InvoiceFactoringService from "../../components/Admin/InvoiceFactoringService";
import LogisticService from "../../components/Admin/LogisticService";
import QualityAssuranceService from "../../components/Admin/QualityAssuranceService";

export default function AdminQuotesDetails() {
  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();
  const { adminJWTToken } = useAppContext();

  const { data, loading } = useFetch<TransactionSummaryRes>(
    get_by_transaction_id,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${adminJWTToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ transaction_id: id }),
    },
    id
  );

  // console.log(data);

  if (loading) return <p className="text-center text-xl mt-10">loading..</p>;

  return (
    <div className="card my-8">
      <div className="p-3">
        <div className="mb-6 flex justify-between items-center pb-3 border-b">
          <h2 className="text-xl font-bold text-gray-800">Quotes</h2>
          <button
            className="text-sm text-gray-600 border px-3 py-1.5 rounded-lg hover:bg-gray-100"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
        </div>

        <div className="mb-4 flex gap-8">
          <p>
            <strong>Transaction ID:</strong> {id}
          </p>
          <p>
            <strong>Client:</strong>
          </p>
          <p>
            <strong>Date:</strong>
          </p>
        </div>
        <hr />

        <div className="space-y-8">
          {data?.simple_payment_data && (
            <PaymentService simplePaymentData={data?.simple_payment_data} />
          )}

          {data?.invoice_factoring_data && (
            <InvoiceFactoringService
              invoiceFactoringData={data.invoice_factoring_data}
            />
          )}

          {data?.logistics_data && (
            <LogisticService logisticsData={data.logistics_data} />
          )}

          {data?.quality_assurance_data && (
            <QualityAssuranceService
              qualityAssuranceData={data.quality_assurance_data}
            />
          )}
        </div>
      </div>
    </div>
  );
}
